import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex'

import national from './national';
import matches from './matches';
import match from './match';
import ui from './ui';

const vuexLocal = new VuexPersistence({
//   key: 'assemble-sports-user',
  storage: window.localStorage,
  modules: ['national', 'match']
});

export default createStore({
  modules: {
    national,
    matches,
    match,
    ui
  },
  plugins: [vuexLocal.plugin]
})
